// extracted by mini-css-extract-plugin
export var standaloneTable = "_g7-0";
export var standaloneTableWithBodyFill = "_g7-1";
export var withExtraHeader = "_g7-2";